export const onlyNumbers = (value) => ('' + value).replace(/[^\d.]/g, '')
